import { PlatformUtility } from 'utility-ts-platform';
import { LoginHelpModalService } from '../../services/login_help_modal_service';
import * as _4 from 'lodash4';

class LoginHelpModalController {
  private isOpen: boolean = true;
  private onClose: () => {};
  private isMobile: boolean = false;
  private login: any;

  constructor(
    private loginConfigModel: any,
    private ngLoginHelpModalService: LoginHelpModalService,
    private appConfigModel: any
  ) {
    this.login = this.appConfigModel.model.LOGIN_HELP;
    this.isMobile = PlatformUtility.isMobile();
  }

  closeDialog(): void {
    this.isOpen = false;
    if (_4.isFunction(this.onClose)) {
      this.onClose();
    }
  }
}

export class LoginHelpModalComponent implements angular.IComponentOptions {
  public templateUrl: string = 'data-ng-authentication/src/components/login_help_modal/login_help_modal.html';
  public controller = LoginHelpModalController;
  public bindings: any = {
    isOpen: '=',
    onClose: '&'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/components/login_help_modal/login_help_modale_controller.ts